import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import JournalTagForm from '../containers/JournalTagFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class JournalTagEditScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `JournalTagEditScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('journal_tag_route_edit')} />
          <JournalTagForm id={this.props.match.params.id} />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default JournalTagEditScreen;

Logger.log('silly', `JournalTagEditScreen loaded.`);
